// extracted by mini-css-extract-plugin
export default {"crossmark":"Crossmark_crossmark__jh5hJ"};